module.exports = __webpack_public_path__ + "img/b7.4234245f.jpg";